<template>
    <div id="popup" class="popup" role="dialog" aria-modal="true">
        <div class="popup__overlay"></div>

        <div class="container container--fluid z-1">
            <div v-click-outside="vcoConfig" class="popup__window">
                <button type="button" class="absolute top-0 right-0 mt-3 mr-3 md:mt-8 md:mr-8" @click.prevent="onClose">
                    <svg class="block w-6 h-6 md:w-8 md:h-8 text-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z" /></svg>
                </button>

                <div class="flex items-center">
                    <aside class="w-1/2 hidden md:block">
                        <slot name="image"></slot>
                    </aside>

                    <section class="md:w-1/2 p-8 text-center">
                        <slot name="form"></slot>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components';

export default {
    directives: {
        clickOutside: vOnClickOutside,
    },

    props: {
        formHandle: {
            type: String,
            required: true,
        },
    },

    emits: ['close'],

    data() {
        return {
            vcoConfig: {
                events: ['mousedown'],
                handler: this.onClickOutside,
            },
        };
    },

    mounted() {
        // Fetch the form we want to deal with
        const form = this.$el;

        // Fetch the new token for the form and replace the CSRF input with our new one
        fetch(`/actions/formie/forms/refresh-tokens?form=${this.formHandle}`)
            .then((result) => { return result.json(); })
            .then((result) => {
                form.querySelector('input[name="CRAFT_CSRF_TOKEN"]').outerHTML = result.csrf.input;

                // Find the JavaScript captcha hidden input, so we can update it
                if (result.captchas && result.captchas.javascript) {
                    const jsCaptcha = result.captchas.javascript;
                    form.querySelector(`input[name="${jsCaptcha.sessionKey}"]`).value = jsCaptcha.value;
                }

                // Find the Duplicate captcha hidden input, so we can update it
                if (result.captchas && result.captchas.duplicate) {
                    const duplicateCaptcha = result.captchas.duplicate;
                    form.querySelector(`input[name="${duplicateCaptcha.sessionKey}"]`).value = duplicateCaptcha.value;
                }
            });
    },

    methods: {
        onClickOutside() {
            this.onClose();
        },
        onClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
    .popup {
        @apply flex fixed inset-0 items-center z-50;

        &__overlay {
            @apply absolute inset-0;

            background-color: rgba(0, 0, 0, 0.5);
        }

        &__window {
            background-color: #edeef1;

            @apply block relative max-w-xl mx-auto rounded-lg overflow-hidden shadow-2xl;
        }
    }
</style>
